// extracted by mini-css-extract-plugin
export default {"card_grid":"home_card_grid__d4iOc"};